<template>
    <div class="board_container template2">
        <div
            class="snapshot_pc template2"
            v-show="showMarketReportData || showMarketComing"
        >
            <div class="data_container">
                <div class="board">
                    <board-pc
                        :params="soldListing"
                        :hasRecentSold="hasRecentSold"
                    ></board-pc>
                    <board-pc
                        :params="avgSalePrice"
                        :hasRecentSold="hasRecentSold"
                    ></board-pc>
                    <board-pc
                        :params="avgDaysOnMarket"
                        :hasRecentSold="hasRecentSold"
                    ></board-pc>
                </div>
                <div
                    class="loading_container"
                    v-show="showMarketReportLoading || showMarketComing"
                >
                    <Loading />
                </div>
            </div>
        </div>
        <!-- <div class="coming_container" v-show="showMarketComing">
            <img
                class="pic"
                src="//static.chimeroi.com/image/snapshot/v2-img-no-market@2x.png"
                alt=""
            />
            <div class="desc">coming soon</div>
        </div> -->
        <div class="location_tips_container" v-show="showMarketNoLocation">
            <img
                class="pic"
                src="//static.chimeroi.com/image/snapshot/v2-img-no-market@2x.png"
                alt
            />
            <div class="desc">
                {{ $t('md-snapshot-search.pleaseInputAValid') }}
            </div>
        </div>
        <div class="no_data" v-show="showMarketNoData">
            <img
                class="pic"
                src="//static.chimeroi.com/image/snapshot/v2-img-no-market@2x.png"
                alt
            />
            <div class="desc">
                {{ noDataText }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from '@/store/helpers';
import Loading from '../../../../../components/loading';
import BoardPc from '../board/pc';
import MoreBtnCommon from '../../../_mixins/more-btn/common';
export default {
    name: 'report-pc',
    components: { 'board-pc': BoardPc, Loading },
    mixins: [MoreBtnCommon],
    computed: {
        ...mapState({
            "showMarketReportData": "showMarketReportData",
            "showMarketReportLoading": "showMarketReportLoading",
            "showMarketNoLocation": "showMarketNoLocation",
            "showMarketComing": "showMarketComing",
            "showMarketNoData": "showMarketNoData"
        }),
        hasRecentSold() {
            return this.soldListing?.status !== 3;
        }
    },
    props: {
        soldListing: {
            required: true
        },
        avgSalePrice: {
            required: true
        },
        avgDaysOnMarket: {
            required: true
        }
    }
};
</script>

<style lang="scss">
@import './board.scss';
.board_container.template2 {
    /* height: 210px; */
    border: solid 1px var(--color-border);
    background-color: #ffffff;
    font-family: var(--font-normal);
    border-radius: 2px;
    .coming_container,
    .location_tips_container,
    >.no_data {
        width: 100%;
        height: 100%;
        padding: 40px 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .pic {
            width: 240px;
            height: 100px;
        }
        .desc {
            margin-top: 20px;
            font-size: 16px;
            padding: 0 20px;
            text-align: center;
            color: var(--color-holder);
        }
    }
}
.snapshot_pc.template2 {
    padding: 40px 30px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .data_container {
        width: 100%;
        height: 70px;
        position: relative;
        .board {
            display: flex;
            &.center {
                justify-content: center;
                .board_card {
                    width: 33.3%;
                    flex: unset;
                }
            }
        }
        .loading_container {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: var(--level-low);
            background: rgba(255, 255, 255, 0.6);
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
    .more {
        margin-top: 40px;
        width: 100%;
        height: 40px;
        border-radius: 2px;
        background-color: var(--color-theme);
        font-size: 16px;
        font-weight: 600;
        color: #ffffff;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        p {
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .button {
            width: 100%;
        }
    }
}
</style>
